import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "./index.css";
import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { Button as s } from "@design-system/button";
import c from "classnames";
import r from "focus-trap-react";
import { forwardRef as t, useRef as n, useState as o, useCallback as i, useEffect as l } from "react";
import { CSSTransition as h } from "react-transition-group";
import { Icon as d } from "@design-system/icon";
import { SearchInput as u } from "@design-system/search-input";
import { Typography as m } from "@design-system/typography";
import { isBrowser as b } from "@phx-husky/browser-helpers";
import { getLocalStorageData as p, setLocalStorageData as g } from "@phx-husky/local-storage";
import { useScreenRecognition as v } from "@phx-husky/use-screen-recognition";
var _ = function _(e) {
    return a = function (e) {
      return b() ? p(e) : null;
    }(e), null === a ? [] : a;
    var a;
  },
  k = function k(e, a, s) {
    if (!e) return;
    var c = _(s),
      r = function (e, a) {
        return e.indexOf(a);
      }(c, e),
      t = -1 !== r ? function (e, a, s) {
        return [e].concat(_toConsumableArray(a.slice(0, s)), _toConsumableArray(a.slice(s + 1)));
      }(e, c, r) : [e].concat(_toConsumableArray(c.slice(0, a - 1)));
    (function (e, a) {
      g(a, e);
    })(t, s);
  },
  f = function f(e, a) {
    a ? a("?q=".concat(e)) : window.location.href = new URL("?q=".concat(e), document.baseURI).href;
  },
  y = t(function (_ref, N) {
    var c = _ref.ariaLabelClose,
      r = _ref.onClick,
      t = _ref.searchInputPlaceholder,
      o = _ref.swipeLabel,
      i = _ref.isMobile,
      l = _ref.userSearches,
      h = _ref.handleSetUserSearches,
      b = _ref.customNavigate,
      p = _ref.localStorageLastSearchesKey,
      g = _ref.lastSearchesQuantity,
      v = _ref.lastSearchesTitle,
      _ = _ref.searchButtonText,
      y = _ref.searchPageUrl,
      S = _ref.autocomplete,
      x = _ref.handleBurgerMenu;
    var O, L;
    var j = n(null),
      w = function w() {
        var e = j.current.value;
        k(e, g, p), h(), f(e, b), r(), null == x || x();
      };
    return e("div", Object.assign({
      ref: N,
      "data-testid": "search-block-container"
    }, {
      children: [a(s, Object.assign({
        className: "cds-search-block__close",
        variant: "subtle-icon",
        size: "large",
        iconPrefix: {
          props: {
            icon: "close"
          }
        },
        onClick: r
      }, {
        children: c
      })), e("div", Object.assign({
        className: "cds-search-block__search-bar-container"
      }, {
        children: [e("div", Object.assign({
          className: "cds-search-block__input-container"
        }, {
          children: [a(d, {
            icon: "search"
          }), a(u, {
            onKeyDown: function onKeyDown(e) {
              j.current && "Enter" === e.key && w();
            },
            placeholder: t,
            inputRef: j,
            searchPageUrl: y,
            autocomplete: S
          })]
        })), a("div", Object.assign({
          className: "cds-search-block__search-btn-container"
        }, {
          children: a(s, Object.assign({
            size: "large",
            variant: "secondary",
            className: "cds-search-block__search-btn",
            onClick: w
          }, {
            children: _
          }))
        })), (null == l ? void 0 : l.length) && (null === (L = null === (O = null == j ? void 0 : j.current) || void 0 === O ? void 0 : O.value) || void 0 === L ? void 0 : L.length) < 3 ? e("div", Object.assign({
          className: "cds-search-block__last-searches-container"
        }, {
          children: [a(m, {
            className: "cds-search-block__last-searches-title",
            variant: "headline",
            size: "s",
            content: v
          }), l.map(function (e) {
            return a(s, Object.assign({
              id: "search-button",
              size: "small",
              variant: "secondary",
              iconPrefix: {
                props: {
                  icon: "search"
                }
              },
              className: "cds-search-block__last-search",
              onClick: function onClick() {
                f(e, b), r(), null == x || x();
              }
            }, {
              children: e
            }), e);
          })]
        })) : null]
      })), i ? e("div", Object.assign({
        className: "cds-search-block__swipe"
      }, {
        children: [a(d, {
          icon: "arrowUp"
        }), a(s, Object.assign({
          size: "large",
          variant: "subtle",
          onClick: r
        }, {
          children: o
        }))]
      })) : null]
    }));
  }),
  S = t(function (_ref2, w) {
    var t = _ref2.className,
      d = _ref2.ariaLabelOpen,
      u = _ref2.ariaLabelClose,
      m = _ref2.swipeLabel,
      p = _ref2.searchInputPlaceholder,
      g = _ref2.searchLabel,
      k = _ref2.customNavigate,
      f = _ref2.localStorageLastSearchesKey,
      S = _ref2.lastSearchesQuantity,
      x = _ref2.lastSearchesTitle,
      N = _ref2.searchButtonText,
      O = _ref2.autocomplete,
      L = _ref2.searchPageUrl,
      j = _ref2.handleBurgerMenu;
    var _o = o(_(f)),
      _o2 = _slicedToArray(_o, 2),
      T = _o2[0],
      C = _o2[1],
      _o3 = o(!1),
      _o4 = _slicedToArray(_o3, 2),
      M = _o4[0],
      P = _o4[1],
      _o5 = o(!1),
      _o6 = _slicedToArray(_o5, 2),
      U = _o6[0],
      B = _o6[1],
      _o7 = o(0),
      _o8 = _slicedToArray(_o7, 2),
      z = _o8[0],
      E = _o8[1],
      _o9 = o(0),
      _o10 = _slicedToArray(_o9, 2),
      D = _o10[0],
      I = _o10[1],
      K = n(null),
      _ref3 = function () {
        var _v = v(),
          e = _v.isMobile;
        return {
          isMobileView: b() && e
        };
      }(),
      R = _ref3.isMobileView,
      Q = "cds-search-block__container",
      Y = U ? "cds-search-block__container cds-search-block__container--mobile" : "cds-search-block__container cds-search-block__container--active",
      q = i(function (e) {
        var a;
        (null === (a = null == K ? void 0 : K.current) || void 0 === a ? void 0 : a.contains(e.target)) || P(!1);
      }, [K]);
    l(function () {
      return document.addEventListener("mousedown", q), function () {
        return document.removeEventListener("mousedown", q);
      };
    }, [K]);
    var A = i(function () {
        P(!M), R && B(!U);
      }, [M, R, B]),
      V = i(function (e) {
        "touchstart" === e.type && (E(e.targetTouches[0].clientY), I(e.targetTouches[0].clientY)), "touchmove" === e.type && I(e.targetTouches[0].clientY);
      }, []),
      $ = i(function () {
        R && z > 150 && z > D && A();
      }, [R, z, D, A]),
      F = i(function () {
        C(_(f));
      }, [f]);
    return e("div", Object.assign({
      ref: w,
      onTouchStart: V,
      onTouchMove: V,
      onTouchEnd: $,
      className: c("cds-search-block", t),
      "data-testid": "cds-search-block"
    }, {
      children: [a(s, Object.assign({
        variant: g ? "nav" : "subtle-icon",
        iconSuffix: {
          props: {
            icon: "search"
          }
        },
        "aria-label": d,
        onClick: A,
        className: "cds-btn__search-icon"
      }, {
        children: g || ""
      })), a(h, Object.assign({
        nodeRef: K,
        in: M,
        timeout: 300,
        classNames: {
          appear: Q,
          appearActive: Q,
          appearDone: Q,
          enter: Y,
          enterDone: Y,
          exit: Q,
          exitActive: Q,
          exitDone: Q
        },
        unmountOnExit: !0
      }, {
        children: a(r, {
          children: a(y, {
            ariaLabelClose: u,
            ariaLabelOpen: d,
            isMobile: R,
            onClick: A,
            ref: K,
            searchInputPlaceholder: p,
            swipeLabel: m,
            userSearches: T,
            handleSetUserSearches: F,
            customNavigate: k,
            localStorageLastSearchesKey: f,
            lastSearchesQuantity: S,
            lastSearchesTitle: x,
            searchButtonText: N,
            autocomplete: O,
            searchPageUrl: L,
            handleBurgerMenu: j
          })
        })
      })), a("div", {
        className: c("cds-search-block__mask", {
          "cds-search-block__mask--active": M
        })
      })]
    }));
  });
export { S as SearchBlock };